/* eslint-disable react/no-unstable-nested-components */
import { KeyboardArrowDown } from '@mui/icons-material';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import useGenre from 'pages/AIMusicGenerator/useGenre';
import aiMusicGeneratorApi from 'services/api/aiMusicGenerator';
import { GenreTypography } from 'pages/AIMusicGenerator/components/FormulaEditor/components/PrimaryGenreSelector/styled';
import { GenreSelectorProps } from '../types';

const PrimaryGenreSelector = ({ value, onChange }: GenreSelectorProps) => {
  const theme = useTheme();
  const { data: genres = [] } =
    aiMusicGeneratorApi.useGetAiMusicGeneratorGenresQuery();
  const genre = useGenre(value);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <FormControl fullWidth>
      <Select
        labelId="primary-genre-select-label"
        data-testid="primary-genre-select"
        sx={{
          borderRadius: theme.spacing(1),
          backgroundColor: theme.palette.grey[800],
          boxShadow: 'none',
        }}
        value={value ?? genres[0]?.name}
        onChange={(event: SelectChangeEvent) => {
          onChange(event.target.value);
        }}
        IconComponent={(props) => (
          <KeyboardArrowDown
            {...props}
            sx={{
              pointerEvents: 'none',
              position: 'absolute',
              right: `${theme.spacing(2)} !important`,
            }}
          />
        )}
        renderValue={() => (
          <Box
            sx={{
              display: 'flex',
              gap: theme.spacing(1),
              alignItems: isMobile ? 'start' : 'center',

              [theme.breakpoints.down('desktop')]: {
                flexDirection: 'column',
              },
            }}
          >
            {!isMobile && (
              <Box
                component="img"
                sx={{
                  height: 'auto',
                  width: theme.spacing(8),
                  aspectRatio: '1 / 1',
                }}
                alt={genre?.description}
                src={genre?.imageUrl}
              />
            )}
            <GenreTypography>{genre?.name}</GenreTypography>
          </Box>
        )}
      >
        {genres.map(({ id, name }) => (
          <MenuItem key={id} value={name}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PrimaryGenreSelector;
